import { ComponentProps } from 'react';

export function SendIcon({ height, width, fill, ...restProps }: ComponentProps<'svg'>) {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M15.4175 2.5497C16.0085 2.33059 16.5899 2.48462 16.9976 2.83681C17.0286 2.85937 17.0595 2.88313 17.0875 2.91103C17.1143 2.93778 17.1368 2.96744 17.1588 2.99696C17.5153 3.40474 17.6728 3.98925 17.4527 4.58388V4.58486L12.9058 16.8515C12.3805 18.266 10.3929 18.1989 9.92438 16.8231L9.88435 16.6854L8.56989 11.4403L3.3111 10.119C1.80157 9.73959 1.69049 7.64072 3.14606 7.0995H3.14704L15.4175 2.5497ZM10.0201 11.0546L11.3394 16.3202H11.3384C11.3435 16.34 11.35 16.3506 11.3531 16.3554C11.3563 16.3602 11.36 16.3641 11.3638 16.3671C11.3727 16.3738 11.3911 16.3822 11.4166 16.3837C11.4419 16.385 11.4609 16.3785 11.4703 16.3729C11.4741 16.3706 11.4777 16.3671 11.481 16.3632C11.4845 16.359 11.4924 16.3489 11.4996 16.33L15.483 5.57997L10.0201 11.0546ZM3.66852 8.50575C3.64994 8.51272 3.63969 8.51979 3.63532 8.52333C3.63125 8.52681 3.62796 8.53117 3.62556 8.53505C3.61992 8.54452 3.61249 8.56354 3.61384 8.58876C3.61531 8.61408 3.62399 8.63207 3.63044 8.64052C3.63321 8.64408 3.63679 8.64733 3.64118 8.65029C3.64566 8.65322 3.65743 8.6599 3.67731 8.66493L8.96149 9.99208L14.4244 4.5165L3.66852 8.50575Z"
        fill={fill || '#1C1C33'}
      />
    </svg>
  );
}

export default SendIcon;
